import { ThemeUIStyleObject } from 'theme-ui';

// The menu is a modal <dialog>, so stacking comes from the top layer. Fixed
// to the viewport, so it opens in view however far the page is scrolled.
// Putaway keeps its menu button pinned while the list scrolls. The rest undoes
// the dialog's own centred box so it covers the whole screen.
export const page: ThemeUIStyleObject = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100dvh',
  maxWidth: 'none',
  maxHeight: 'none',
  margin: 0,
  padding: 0,
  border: 0,
  backgroundColor: 'transparent',
  display: 'flex',
  // Only shows through the click-away strip. Keep it clear, as before.
  '&::backdrop': {
    backgroundColor: 'transparent',
  },
};

export const menuContainerStyle: ThemeUIStyleObject = {
  backgroundColor: 'white',
  borderRightStyle: 'solid',
  borderRightColor: 'backgroundMedium',
  borderRightWidth: '1px',
  padding: '24px 12px',
  width: '324px',
  height: '100%',
  // The full list is taller than a phone screen.
  overflowY: 'auto',
  boxShadow: 'standard',
  display: 'flex',
};

// Phones: the whole screen under the top bar, scrolling on its own.
export const phoneMenuContainerStyle: ThemeUIStyleObject = {
  ...menuContainerStyle,
  width: '100%',
  height: 'auto',
  flex: 1,
  minHeight: 0,
  borderRightWidth: 0,
  boxShadow: 'none',
  overscrollBehavior: 'contain',
};

export const topBarStyle: ThemeUIStyleObject = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  backgroundColor: 'white',
  borderBottom: '1px solid',
  borderBottomColor: 'backgroundMedium',
};

// The heading font draws ‹ as a speck, so draw the chevron instead, as the
// Putaway sheet's back buttons do.
export const backButtonStyle: ThemeUIStyleObject = {
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: 0,
  color: 'mocha',
  cursor: 'pointer',
  display: 'inline-flex',
  fontFamily: 'heading',
  fontSize: '14px',
  fontWeight: 700,
  gap: '6px',
  minHeight: '48px',
  // Padding inside the button, so the tap target runs to the screen edge.
  pl: '12px',
  pr: '16px',
  py: 0,
  '&::before': {
    borderBottom: '2px solid',
    borderLeft: '2px solid',
    content: '""',
    height: '6px',
    ml: '2px',
    transform: 'rotate(45deg)',
    width: '6px',
  },
  '&:focus-visible': {
    outline: '3px solid',
    outlineColor: 'primaryBackgroundActive',
    outlineOffset: '-3px',
  },
};

export const notMenuStyle: ThemeUIStyleObject = {
  width: 'calc(100% - 324px)',
  height: '100%',
};

export const innerContainerStyle: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
};

export const headerContainerStyle: ThemeUIStyleObject = {
  display: 'flex',
  marginBottom: '24px',
  marginRight: '10px',
};

export const header: ThemeUIStyleObject = {
  fontFamily: 'heading',
  fontSize: '16px',
  marginLeft: '8px',
  marginTop: '3px',
};

export const navLinkContainer: ThemeUIStyleObject = {
  width: '100%',
  display: 'flex',
  cursor: 'pointer',
  padding: '12px',
  borderRadius: 2,
  '&:hover': {
    backgroundColor: 'backgroundMedium',
  },
  color: 'black',
  textDecoration: 'none',
};

export const navLinkLabel: ThemeUIStyleObject = {
  marginLeft: '12px',
  marginTop: '4px',
  fontFamily: 'body',
  fontSize: '14px',
};

export const helpLinkLabel: ThemeUIStyleObject = {
  marginLeft: '12px',
  marginTop: '2px',
  fontFamily: 'body',
  fontSize: '14px',
  color: 'text',
};

// A button with the old div's box.
export const exitContainer: ThemeUIStyleObject = {
  padding: '3px 15px 3px 20px',
  cursor: 'pointer',
  height: '30px',
  backgroundColor: 'transparent',
  border: 0,
  display: 'flex',
  '&:focus-visible': {
    outline: '3px solid',
    outlineColor: 'primaryBackgroundActive',
    outlineOffset: '-3px',
  },
};

export const issuesSymbol = { marginX: '5px' };

export const warehouseOperationsSymbol = { marginX: '2px' };
